// 前提：gsap と ScrollTrigger を読み込み済み
gsap.registerPlugin(ScrollTrigger);

const SCROLL_ANIM = (() => {
  // 柔らか・エレガント寄りプリセット
  const PRESETS = {
    // 移動なしのふわっとフェード
    fade: { autoAlpha: 0, ease: "power2.out" },
    "fade-in": { autoAlpha: 0, ease: "power2.out" }, // alias
    "fade-up": { y: 12, autoAlpha: 0, scale: 1, ease: "power2.out" },
    "fade-down": { y: -12, autoAlpha: 0, scale: 1, ease: "power2.out" },
    "fade-left": { x: -12, autoAlpha: 0, scale: 1, ease: "power2.out" },
    "fade-right": { x: 12, autoAlpha: 0, scale: 1, ease: "power2.out" },
    "zoom-in": {
      scale: 0.985,
      autoAlpha: 0,
      ease: "power2.out",
      transformOrigin: "50% 50%",
    },
    "flip-up": {
      rotationX: -6,
      transformPerspective: 800,
      autoAlpha: 0,
      ease: "power2.out",
    },
  };

  // prefers-reduced-motion 対応
  const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // 単体要素用
  function buildSingle(el) {
    const type = (el.dataset.anim || "").trim();
    if (!type || !PRESETS[type]) return;

    const duration = parseFloat(el.dataset.duration || 0.9); // 柔らかめ
    const delay = parseFloat(el.dataset.delay || 0);
    const start = el.dataset.start || "top 80%";
    const once = el.dataset.once === "true";
    const scrub = el.dataset.scrub
      ? parseFloat(el.dataset.scrub) || true
      : false;
    const blur = parseFloat(el.dataset.blur || 0);
    const ease = (el.dataset.ease || "").trim();

    const fromVars = Object.assign({}, PRESETS[type]);
    if (blur) fromVars.filter = `blur(${blur}px)`;
    if (ease) fromVars.ease = ease;

    const tweenVars = {
      duration,
      delay,
      scrollTrigger: {
        trigger: el,
        start,
        toggleActions: once ? "play none none none" : "play none none reverse",
        markers: false,
        scrub: scrub,
      },
    };

    if (REDUCED) {
      gsap.set(el, { clearProps: "all", autoAlpha: 1 });
      return;
    }

    // from でぼかし→クリアにも対応（filter 未指定なら何もしない）
    gsap.from(el, Object.assign({}, fromVars, tweenVars));
  }

  // グループ用：親に data-anim-group、子セレクタを data-target で指定
  function buildGroup(container) {
    const type = (container.dataset.animGroup || "").trim();
    if (!type || !PRESETS[type]) return;

    const targetSel = container.dataset.target || "> *";
    const targets = container.matches(targetSel)
      ? [container]
      : container.querySelectorAll(targetSel);
    if (!targets.length) return;

    const duration = parseFloat(container.dataset.duration || 0.9); // 柔らかめ
    const delay = parseFloat(container.dataset.delay || 0);
    const stagger = parseFloat(container.dataset.stagger || 0.14); // テンポを少しだけ良く
    const start = container.dataset.start || "top 80%";
    const once = container.dataset.once === "true";
    const scrub = container.dataset.scrub
      ? parseFloat(container.dataset.scrub) || true
      : false;
    const blur = parseFloat(container.dataset.blur || 0);
    const ease = (container.dataset.ease || "").trim();

    const fromVars = Object.assign({}, PRESETS[type]);
    if (blur) fromVars.filter = `blur(${blur}px)`;
    if (ease) fromVars.ease = ease;

    const tweenVars = {
      duration,
      delay,
      stagger,
      scrollTrigger: {
        trigger: container,
        start,
        toggleActions: once ? "play none none none" : "play none none reverse",
        markers: false,
        scrub: scrub,
      },
    };

    if (REDUCED) {
      gsap.set(targets, { clearProps: "all", autoAlpha: 1 });
      return;
    }

    gsap.from(targets, Object.assign({}, fromVars, tweenVars));
  }

  function init(root = document) {
    // 単体
    root.querySelectorAll("[data-anim]").forEach(buildSingle);
    // グループ
    root.querySelectorAll("[data-anim-group]").forEach(buildGroup);

    // 画像やWebフォント読み込みで高さ変化 -> 再計測
    window.addEventListener("load", () => ScrollTrigger.refresh());
  }

  return { init };
})();

// DOM 準備後に実行
document.addEventListener("DOMContentLoaded", () => {
  SCROLL_ANIM.init();
});
